import { ReactElement, ReactNode, HTMLAttributes } from 'react';
import clsx from 'clsx';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  size?: 'default' | 'large';
  padding?: boolean;
  transparentOnMobile?: boolean;
}

function Card({
  children,
  className,
  size = 'default',
  padding = true,
  transparentOnMobile = false,
  ...rest
}: CardProps): ReactElement {
  return (
    <div
      data-testid="card"
      className={clsx(
        'mx-auto text-center rounded-large w-full',
        {
          'px-2 tablet:px-6 py-5': padding,
        },
        {
          'max-w-default': size === 'default',
          'max-w-large': size === 'large',
        },
        {
          'bg-card shadow-card': !transparentOnMobile,
          'bg-transparent tablet:bg-card tablet:shadow-card':
            transparentOnMobile,
        },
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;
